export default __webpack_public_path__ + "static/about-ellips-small-44dbe24b44607827fd6a8cd8cb13ae2b.gif";